<script setup lang="ts">
import { useShortcuts } from '#core/composables/useShortcuts'
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { Button } from '@forgd/ui-kit/button'
import { Kbd, KbdGroup } from '@forgd/ui-kit/kbd'

const { toggleContentSearch } = useUIState()
const { metaSymbol } = useShortcuts()
</script>

<template>
  <Button
    variant="outline"
    size="sm"
    class="w-50 py-2"
    @click="toggleContentSearch"
  >
    <MagnifyingGlassIcon aria-hidden="true" />
    <span class="truncate font-normal">Search on Forgd</span>
    <KbdGroup class="hidden lg:inline-flex ml-auto -my-1">
      <Kbd>
        {{ metaSymbol }}
      </Kbd>
      <Kbd>
        K
      </Kbd>
    </KbdGroup>
  </Button>
</template>
